// extracted by mini-css-extract-plugin
export default {"container":"CharacterProsCons_container__H0Wpg","listItem":"CharacterProsCons_listItem__a67W-","row":"CharacterProsCons_row__uNYe9"};